/**
 * Per-status badge theme + icon for subscription statuses.
 *
 * Shared by the subscription list view (SubscriptionListView) and the contact
 * "Dons réguliers" tab (ContactSubscriptionsTab) so the colour + icon mapping
 * lives in one place. Mirrors `donationStatusBadge.ts` for donations.
 */
export const subscriptionStatusTheme = {
    Active: "green",
    Paused: "orange",
    Canceled: "red",
    Expired: "neutral",
};
export const subscriptionStatusIcon = {
    Active: "ri-check-fill",
    Paused: "ri-pause-circle-fill",
    Canceled: "ri-forbid-fill",
    Expired: "ri-time-line",
};
